import { render, staticRenderFns } from "./ManagerNav.vue?vue&type=template&id=1756c031&scoped=true&"
import script from "./ManagerNav.vue?vue&type=script&lang=js&"
export * from "./ManagerNav.vue?vue&type=script&lang=js&"
import style0 from "./ManagerNav.vue?vue&type=style&index=0&id=1756c031&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1756c031",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
